
function getRowNo(list: any) {
    const newList = list.map((item: any, idx: number) => ({
        ...item,
        rowNo: idx+1
    }))

    return newList;
}

export default getRowNo;